import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  height: 100%;
  overflow-y: hidden;
  overscroll-behavior: contain;

  textarea.editable {
    border: 0;
    margin: 0;
    padding: 0;
    font-size: 1.2rem;
    font-family: Inter;
    width: 100%;
    text-align: left;
    display: block;
    text-align: left;
    outline: none;
    line-height: 1.5em;
    resize: none;
    background: transparent;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    color: var(--icon-button-fill);
    -webkit-text-fill-color: var(--icon-button-fill);

    &:disabled {
      background: none;
    }
  }

  &.editing {
    overflow-y: scroll;

    textarea.editable {
      cursor: text;
    }
  }
`;
